import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from "react-router-dom";
import { logOut } from './../util'
import SimpleTextDialog from '../dialogs/simple-text-dialog';

export default function QrCodeMenu({ token, setToken, open, setOpen, anchorEl, setAnchorEl, anchorData, setAnchorData, setSelectedQrCodeId, setQrData }) {
    let [editNameDialogOpen, setEditNameDialogOpen] = useState(false);
    let navigate = useNavigate()

    const handleClose = () => {
        setAnchorEl(null);
        setAnchorData(null);
        setOpen(false)
    };

    const handleEditName = () => {
        setAnchorEl(null)
        setEditNameDialogOpen(true)
        setOpen(false)
    };

    const deleteQrCode = () => {
        fetch('/api/qr-codes/' + anchorData._id, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
        })
            .then(response => {
                if (response.status !== 200) {
                    if (response.status === 401) {
                        logOut({ navigate, setToken })
                    }
                    console.log('QR code not deleted');
                } else {
                    handleClose()
                    setQrData(qrs => qrs.filter(qr => qr._id !== anchorData._id))
                    setSelectedQrCodeId(null)
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    return (
        <React.Fragment>
            <Menu
                id="qr-code-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={handleEditName}>Edit name</MenuItem>
                <MenuItem onClick={deleteQrCode} sx={{ color: 'firebrick' }}>Delete</MenuItem>
            </Menu>
            <SimpleTextDialog
                token={token}
                setToken={setToken}
                open={editNameDialogOpen}
                setOpen={setEditNameDialogOpen}
                handleCloseExternal={handleClose}
                apiEndpoint={'/api/qr-codes/' + anchorData?._id}
                value={anchorData}
                setValue={setQrData}
                dialogTitle={"Edit QR code name"}
                dbFieldname={"name"}
                inputLabel={"Name"}
                entityId={anchorData?._id}
                accountId={anchorData?.accountId}
            />
        </React.Fragment>
    );
}
